import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './contexts/AuthContext'; // Added import

// In production, disable all console output to avoid exposing logs in browser
if (process.env.NODE_ENV === 'production') {
  const noop = () => {};
  ['log','debug','info','warn','error'].forEach(fn => {
    try { if (console && typeof console[fn] === 'function') console[fn] = noop; } catch (_) {}
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <AuthProvider> 
      <App />
    </AuthProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
